import { CgWebsite } from "react-icons/cg";
import {
  FaAws,
  FaBolt,
  FaChartBar,
  FaCodeBranch,
  FaCubes,
  FaDatabase,
  FaDesktop,
  FaHeartbeat,
  FaMagic,
  FaMobileAlt,
  FaNodeJs,
  FaPlug,
  FaProjectDiagram,
  FaReact,
  FaRegWindowMaximize,
  FaSitemap,
  FaUsers,
  FaWpforms,
} from "react-icons/fa";
import {
  SiBootstrap,
  SiDjango,
  SiExpress,
  SiJavascript,
  SiMongodb,
  SiNextdotjs,
  SiPostgresql,
  SiTailwindcss,
  SiTypescript,
} from "react-icons/si";

export function getSkillChipLabelWidth(label) {
  return `${Math.min(Math.max(label.length * 0.44 + 0.8, 2.8), 8.2)}rem`;
}

export function getSkillPresentation(label) {
  const normalizedLabel = String(label || "").toLowerCase();

  if (normalizedLabel.includes("react hook form")) {
    return { Icon: FaWpforms, color: "#ff7aa2" };
  }

  if (normalizedLabel.includes("react query")) {
    return { Icon: FaBolt, color: "#ffd166" };
  }

  if (normalizedLabel.includes("framer")) {
    return { Icon: FaMagic, color: "#ffb454" };
  }

  if (normalizedLabel.includes("next")) {
    return { Icon: SiNextdotjs, color: "#f3f7fb" };
  }

  if (normalizedLabel.includes("typescript")) {
    return { Icon: SiTypescript, color: "#3178c6" };
  }

  if (normalizedLabel.includes("javascript")) {
    return { Icon: SiJavascript, color: "#f7df1e" };
  }

  if (normalizedLabel.includes("tailwind")) {
    return { Icon: SiTailwindcss, color: "#38bdf8" };
  }

  if (normalizedLabel.includes("bootstrap")) {
    return { Icon: SiBootstrap, color: "#a78bfa" };
  }

  if (normalizedLabel.includes("postgres")) {
    return { Icon: SiPostgresql, color: "#87a6ff" };
  }

  if (normalizedLabel.includes("mongo")) {
    return { Icon: SiMongodb, color: "#47a248" };
  }

  if (normalizedLabel.includes("django")) {
    return { Icon: SiDjango, color: "#34d399" };
  }

  if (normalizedLabel.includes("express")) {
    return { Icon: SiExpress, color: "#d8dee9" };
  }

  if (normalizedLabel.includes("rest api") || normalizedLabel.includes("api")) {
    return { Icon: FaPlug, color: "#60d5ff" };
  }

  if (normalizedLabel.includes("postgres") || normalizedLabel.includes("database")) {
    return { Icon: FaDatabase, color: "#87a6ff" };
  }

  if (normalizedLabel.includes("node")) {
    return { Icon: FaNodeJs, color: "#66bb6a" };
  }

  if (normalizedLabel.includes("recharts") || normalizedLabel.includes("chart")) {
    return { Icon: FaChartBar, color: "#7c8cff" };
  }

  if (normalizedLabel.includes("react")) {
    return { Icon: FaReact, color: "#61dafb" };
  }

  if (normalizedLabel.includes("frontend architecture") || normalizedLabel.includes("architecture")) {
    return { Icon: FaSitemap, color: "#8fd3ff" };
  }

  if (normalizedLabel.includes("component")) {
    return { Icon: FaCubes, color: "#c9d2df" };
  }

  if (normalizedLabel.includes("ci/cd") || normalizedLabel.includes("pipeline")) {
    return { Icon: FaCodeBranch, color: "#f7b267" };
  }

  if (normalizedLabel.includes("aws")) {
    return { Icon: FaAws, color: "#ffb454" };
  }

  if (normalizedLabel.includes("workflow")) {
    return { Icon: FaProjectDiagram, color: "#66d6a6" };
  }

  if (normalizedLabel.includes("form")) {
    return { Icon: FaWpforms, color: "#ff7aa2" };
  }

  if (normalizedLabel.includes("role") || normalizedLabel.includes("views")) {
    return { Icon: FaUsers, color: "#f7b267" };
  }

  if (
    normalizedLabel.includes("interface") ||
    normalizedLabel.includes("dashboard")
  ) {
    return { Icon: FaDesktop, color: "#60d5ff" };
  }

  if (normalizedLabel.includes("care") || normalizedLabel.includes("health")) {
    return { Icon: FaHeartbeat, color: "#ff6b7a" };
  }

  if (normalizedLabel.includes("responsive") || normalizedLabel.includes("mobile")) {
    return { Icon: FaMobileAlt, color: "#7ec8ff" };
  }

  if (
    normalizedLabel.includes("web app ux") ||
    normalizedLabel.includes("ux") ||
    normalizedLabel.includes("screen") ||
    normalizedLabel.includes("ui")
  ) {
    return { Icon: FaRegWindowMaximize, color: "#c9d2df" };
  }

  return { Icon: CgWebsite, color: "#60d5ff" };
}